export default __webpack_public_path__ + "static/media/money.1639f491.svg";